import { render, staticRenderFns } from "./create-folder.vue?vue&type=template&id=6925a952&scoped=true"
import script from "./create-folder.vue?vue&type=script&lang=js"
export * from "./create-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925a952",
  null
  
)

export default component.exports